import {combineReducers} from 'redux'
import {
  GET_MODULES_SUCCESS,
  GET_MODULES_ERROR,
  SUBMIT_FEEDBACK_SUCCESS,
  SUBMIT_FEEDBACK_ERROR,
  SET_VIDSIZE_SUCCESS,
  SET_VOLUNTARY_SUCCESS,
  GET_FEEDBACK_GROUP_SUCCESS,
  GET_FEEDBACK_GROUP_ERROR,
  GET_VIDEOS_SUCCESS,
  GET_VIDEOS_ERROR,
} from '../constants'

export const modules = (state = [], action) => {
  switch (action.type) {
    case GET_MODULES_SUCCESS:
      return action.modules
    case GET_MODULES_ERROR:
      return action.success
    default:
      return state
  }
}

export const feedbackSuccess = (state = false, action) => {
  switch (action.type) {
    case SUBMIT_FEEDBACK_SUCCESS:
      return action.success
    case SUBMIT_FEEDBACK_ERROR:
      return action.success
    default:
      return state
  }
}

export const voluntary = (state = false, action) => {
  switch (action.type) {
    case SET_VOLUNTARY_SUCCESS:
      return action.voluntary
    default:
      return state
  }
}

export const vidSize = (state = 0, action) => {
  switch (action.type) {
    case SET_VIDSIZE_SUCCESS:
      return action.size
    default:
      return state
  }
}

export const feedbackGroup = (state = [], action) => {
  switch (action.type) {
    case GET_FEEDBACK_GROUP_SUCCESS:
      return action.feedbackGroup
    case GET_FEEDBACK_GROUP_ERROR:
      return []
    default:
      return state
  }
}

export const videoModule = (state = [], action) => {
  switch (action.type) {
    case GET_VIDEOS_SUCCESS:
      return action.videoModule
    case GET_VIDEOS_ERROR:
      return []
    default:
      return state
  }
}

export default combineReducers({
  modules,
  feedbackSuccess,
  voluntary,
  vidSize,
  feedbackGroup,
  videoModule,
})